import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window on every route change.
 *
 * - No hash → reset to (0, 0) so each new page starts from the top.
 * - Hash present → actively scroll the matching `#id` element into view via
 *   requestAnimationFrame + a short fallback, because React/framer-motion
 *   sections often mount AFTER the browser's native anchor pass has fired,
 *   leaving deep links like `/about#scientific-advisor` stuck at the top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ block: 'start' });
      };
      requestAnimationFrame(tryScroll);
      // Fallback: framer-motion sections sometimes mount on a later tick.
      const t = setTimeout(tryScroll, 300);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
